/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import PrintModal from '../../components/Sourcing/PrintModal';
import { del } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import OrderModal from '../../components/Sourcing/OrderModal';

function Orders(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editModalOrder, setEditModalOrder] = useState({});
  const [printModalOpen, setPrintModalOpen] = useState(false);
  const [printModalOrder, setPrintModalOrder] = useState({});
  const [signal, setSignal] = useState(0);

  const editOrder = (order) => {
    setEditModalOrder(order);
    setEditModalOpen(true);
  };

  const printOrder = (order) => {
    setPrintModalOrder(order);
    setPrintModalOpen(true);
  };

  const deleteOrder = async (order, e) => {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    // eslint-disable-next-line no-alert
    const cnfrm = confirm(props.t(`Are you sure you want to delete ${order.reference}?`));

    if (cnfrm) {
      try {
        await del(`/api/sourcing/orders/${order.id}`);

        toastr.success(`Deleted order ID: ${order.id}`, 'Success');
        setSignal(signal + 1);
      } catch (error) {
        toastr.error(error.message, 'Error');
      } finally {
        btn.disabled = false;
        btn.firstChild.classList.toggle('bx-spin');
      }
    }
  };

  const onEditSuccess = () => {
    setSignal(signal + 1);
  };

  const onPrintSuccess = () => {
    setSignal(signal + 1);
    setPrintModalOpen(false);
    setPrintModalOrder({});
  };

  const createEntity = () => {
    setEditModalOrder({
      reference: '',
      shipments: [],
      items: [],
    });
    setEditModalOpen(true);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="11">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Supplier Orders')}</CardTitle>

                <Can i="see" this="Sourcing">
                  <BaseGrid
                    url="/api/sourcing/orders"
                    hasSearch
                    shouldUpdate={signal}
                    create={createEntity}
                    config={
                    {
                      columns: {
                        id: {
                          label: 'ID',
                          sort: true,
                          link: {
                            to: '/sourcing/order/%id%',
                          },
                        },
                        lot: { label: 'Lot', sort: true },
                        supplier: {
                          label: 'Supplier',
                          sort: false,
                          format: (x) => (
                            x.name
                          ),
                        },
                        supplier_program: { label: 'Program', sort: true },
                        created_at: {
                          label: 'Created At',
                          date: {
                            format: (date) => (moment(date).fromNow()),
                            timezone: process.env.LOCAL_TZ,
                          },
                          sort: true,
                        },
                        inductions: {
                          label: 'Costed',
                          format: (x) => (x.find((y) => y.cost == null) || x.length === 0 ? '' : '✅'),
                          sort: false,
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'print',
                              icon: 'mdi mdi-printer',
                              class: 'btn btn-sm btn-soft-info',
                              alt: props.t('Print'),
                              click: printOrder,
                            },
                            {
                              key: 'edit',
                              icon: 'bx bx-pencil',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: props.t('Edit'),
                              click: editOrder,
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteOrder,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 10,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Sourcing"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <OrderModal
        shown={editModalOpen}
        item={editModalOrder}
        onSuccess={onEditSuccess}
        onCancel={() => { setEditModalOpen(false); }}
      />
      <PrintModal
        shown={printModalOpen}
        item={printModalOrder}
        onSuccess={onPrintSuccess}
        onCancel={() => { setPrintModalOpen(false); }}
      />
    </div>
  );
}

Orders.defaultProps = {
  t: (x) => (x),
};

Orders.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Orders));
